export default "__VITE_ASSET__SpZkMxpG__"